import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useOperatorsCacheUpdater } from "../../useFetchOperators";

interface DeleteOperatorVariables {
  sectionId: string;
  operatorId: string;
}

export const useDeleteOperator = () => {
  const { removeActiveOperator } = useOperatorsCacheUpdater();

  return useBoronMutation<void, DeleteOperatorVariables>(
    ({ sectionId, operatorId }: DeleteOperatorVariables) =>
      boronClient.DELETE(
        "/api/v1/sections/{section_id}/operators/{operator_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              operator_hashid: operatorId,
            },
          },
        },
      ),
    {
      onSuccess: (_, { sectionId, operatorId }) => {
        removeActiveOperator(sectionId, operatorId);
      },
    },
  );
};
